import { Link, TrackingData } from '@ecm/router';

export class LasBillViewModel {
    public date?: string;
    public amount?: number;
    public isUnpaid?: boolean;
    public link: Link;
    public trackingData?: TrackingData;
}
